import { Vibrant } from "./configs/browser";
import { pipeline } from "./pipeline";

Vibrant.use(pipeline);

export { Vibrant };
